export default "<p>student-dashboard works!</p>\n"